module.exports = __webpack_public_path__ + "img/cshomework1.147063d0.png";